import React from "react";
import "./wmModals.css";
import Modal from "react-bootstrap/Modal";

function WmModals(props,className) {
  return (
    <React.Fragment>
      <Modal
      className={className}
        {...props}
        size={`${props.size}`}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        {props.children}
      </Modal>
    </React.Fragment>
  );
}

export default WmModals;
